import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/core/base.component';
import { SessionService } from 'src/app/shared/services/session.service';
import { StringHelpers } from 'src/app/shared/helpers/string-helpers';
import { MatDialog } from '@angular/material/dialog';
import { Sort } from '@angular/material/sort';
import { AlertModalComponent } from 'src/app/shared/modals/alert-modal/alert-modal.component';
import { DigitalWaiverService } from '../../services/digital-waiver.service';
import { EntriesListQueryFilter } from './entries-list-query-filter';
import { DigitalWaiverEntryList } from '../../models/digital-waiver-entry-list';
import { WaiverEntriesQuickViewComponent } from '../../modals/waiver/entries-quick-view/waiver-entries-quick-view.component';
import { WaiverEntryManualCreateModalComponent } from '../../modals/waiver/waiver-entry-manually-create-modal/waiver-entry-manual-create-modal.component';

@Component({
    selector: 'app-entries-list',
    templateUrl: './entries-list.component.html',
    styleUrl: './entries-list.component.scss',
    standalone: false
})
export class EntriesListComponent extends BaseComponent implements OnInit {
    @Input() filter: EntriesListQueryFilter = new EntriesListQueryFilter();
    public updateFilterEvent = new EventEmitter<any>();
    public entries: DigitalWaiverEntryList[] = []; 

    constructor(
        sessionService: SessionService,
        private digitalWaiverService: DigitalWaiverService,
        private dialog: MatDialog,
        stringHelpers: StringHelpers
    ) {
        super(sessionService, stringHelpers);
        this.displayedColumns = ['firstName', 'lastName', 'emailAddress', 'booking', 'status', 'lastEditedDate', 'actions'];
        this.filter.organizationId = this.sessionService.getUser().organizationId;
    }

    ngOnInit(): void {
        this.getEntries();
    }

    getEntries() {
        this.isLoading = true;
        this.digitalWaiverService.getWaiverEntries(this.filter).subscribe({
            next: (result) => {
                this.entries = result.results;
                this.filter.totalCount = result.totalCount;
                this.updateFilterEvent.emit(result.results);
            },
            error: (error) => {
                this.isLoading = false;
                console.error(error);
            },
            complete: () => this.isLoading = false
        });
    }

    sortData(sort: Sort) {
        this.filter.sortDirection = sort.direction;
        this.filter.sortColumn = sort.active;
        this.getEntries();
    }

    resetFilter() {
        this.filter.page = 1;
        this.filter.text = '';
        this.filter.pageSize = 15;
    }

    updateIsActive(entry: any, event: any) {
        this.isLoading = true;
        entry.isActive = event;
        entry.lastEditedBy = this.sessionService.getUserId();
        this.digitalWaiverService.updateWaiver(entry.id, entry).subscribe({
            next: () => {
                this.getEntries();
            },
            error: (error) => {
                this.isLoading = false;
                console.error(error);
            },
            complete: () => this.isLoading = false
        });
    }

    createManuallySendEntry() {
        const dialogRef = this.dialog.open(WaiverEntryManualCreateModalComponent, {
            width: '900px'
        });

        dialogRef.afterClosed().subscribe(result => {
            if(result === 'save') {
                this.getEntries();
            }
        });
    }

    openQuickview(entry: DigitalWaiverEntryList) {
        const dialogRef = this.dialog.open(WaiverEntriesQuickViewComponent, {
            width: '40vw',
            data: entry
        });
    }

    resendWaiver(entry: any) {
        this.isLoading = true;

        let now = new Date();
        const nowUtc = new Date(Date.UTC(
            now.getFullYear(),
            now.getMonth(),
            now.getDate(),
            now.getHours(),
            now.getMinutes()
          ));

        const data = {
            id: entry.id,
            firstName: entry.firstName,
            lastName: entry.lastName,
            emailAddress: entry.emailAddress,
            digitalWaiverEntryId: entry.id,
            digitalWaiverId: entry.digitalWaiverId,
            bookingId: entry.bookingId,
            sentDate: nowUtc,
            userId: this.sessionService.getUserId(),
            lastEditedBy: this.sessionService.getUserId(),
            organizationId: this.sessionService.getUser().organizationId
        };


        this.digitalWaiverService.resendDigitalWaiverEntry(data).subscribe({
            next: () => {
                this.isLoading = false;
                this.getEntries();
            },
            error: (error) => {
                console.error(error);
                this.isLoading = false;
            }
        });
    }

    delete(entry: any) {
        const dialogRef = this.dialog.open(AlertModalComponent);
        dialogRef.componentInstance.title = 'Delete Waiver';
        dialogRef.componentInstance.body = `<h3 class="text-danger mat-h3">WARNING! THIS ACTION CANNOT BE UNDONE</h3> <br /> Are you sure you want to delete Waiver <strong>${entry.title}</strong>?`;
        dialogRef.componentInstance.submitText = 'Yes';
        dialogRef.componentInstance.otherText = 'No';
        dialogRef.componentInstance.isOtherTextDisabled = false;
        
        dialogRef.afterClosed().subscribe((response) => {
            if(response === 'Yes') {
                this.isLoading = true;
                let data = {id: entry.id, lastEditedBy: this.sessionService.getUserId()};
                this.digitalWaiverService.deleteWaiverEntry(data).subscribe(() => {
                    this.getEntries();
                    this.isLoading = false;
                }, err => {
                    this.isLoading = false;
                    console.error(err);
                });
            }
        });
    }

    canResendWaiver(entry: any) {
        const now = new Date();
        const bookingStartDate = new Date(entry.startTime);
        return bookingStartDate >= now;
    }
}
